/* MXDVS wishlist icon dot (06.10.2026). Used by sections/mxdvs-wish-icon.liquid.
   Every wishlist icon on the page ([data-mx-wishlist-icon]) gets the class is-lit while something
   is saved in this browser (localStorage mxWishlist), which shows the small dot. Updates straight
   away when the product page save button fires mx:wishlist, when another tab changes the list,
   and when the visitor comes back with the browser's back button. Loaded once. */
(function () {
  if (window.__mxWishIcon) return;
  window.__mxWishIcon = true;
  function count() {
    try { return JSON.parse(localStorage.getItem('mxWishlist') || '[]').length; } catch (e) { return 0; }
  }
  function light(n) {
    document.querySelectorAll('[data-mx-wishlist-icon]').forEach(function (el) {
      el.classList.toggle('is-lit', n > 0);
      var c = el.querySelector('.mx-wish__count');
      if (c) c.textContent = n > 0 ? ', ' + n + ' saved' : '';
    });
  }
  function run() { light(count()); }
  document.addEventListener('mx:wishlist', function (e) {
    light(e.detail && typeof e.detail.count === 'number' ? e.detail.count : count());
  });
  window.addEventListener('storage', function (e) { if (e.key === 'mxWishlist') run(); });
  window.addEventListener('pageshow', run);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
